angular.module('cfn').factory('cfnGridSizing', function() {
  var service = {};

  service.init = function(scope, element, attrs) {
    var serviceInstance = {};
    scope.calculateWidths = function(settingWidth) {
      if (settingWidth === undefined) {
        settingWidth = scope.width;
      }

      settingWidth -= 5;
      var displayPrio = 100;

      if (settingWidth < 900) {
        displayPrio = 6;
      }
      if (settingWidth < 750) {
        displayPrio = 5;
      }
      if (settingWidth < 600) {
        displayPrio = 4;
      }
      if (settingWidth < 500) {
        displayPrio = 3;
      }
      if (settingWidth < 400) {
        displayPrio = 2;
      }
      if (settingWidth < 250) {
        displayPrio = 1;
      }

      var gridWidth = settingWidth;

      var size = 0;
      var count = 0;
      if (scope.checkboxselectable === 'true') {
        gridWidth -= 30; // needs to be the same as in css
      }
      if (scope.deleteable === 'true') {
        gridWidth -= 30; // needs to be the same as in css
      }

      if (scope.fixedcols) {
        // if there are fixed and nonfixed columns, the fixed part of the grid should be 50%;
        gridWidth /= 2;
      }

      if (scope.printable === 'true') {
        // 20px witdh of vertical-scrollbar. (fixedcols, no vertical-scrollbar available)
        gridWidth -= 20;
      }

      // console.debug("updating width",settingWidth);

      var i,
        fixedcols = parseInt(scope.fixedcols);

      for (i in scope.columns) {
        var col = scope.columns[i];
        col.isHidden = false;
        if (col.hidden != undefined) {
          col.isHidden = scope.$parent.$eval(col.hidden);
        }

        col.isNonfixed = scope.fixedcols && i >= fixedcols;

        // show only the first six columns if details view is displayed
        if (scope.window && scope.window.displayRight && i > 5)
          col.isHidden = true;

        if (
          parseInt(col.displayprio) <= displayPrio &&
          !col.isHidden &&
          !col.isNonfixed
        ) {
          count++;
          size += parseInt(col.displaysize);
        }
      }

      // actually change visibility and size
      var sizes = [];
      var widthMaxed = 0;
      var recalcSize = 0;
      var i;
      for (i in scope.columns) {
        var col = scope.columns[i];
        if (parseInt(col.displayprio) <= displayPrio && !col.isHidden) {
          var w = Math.floor(parseInt(col.displaysize) * gridWidth / size); // calculated column width
          sizes[i] = {
            w: w
          };
          var realW = w;
          if (col.width) {
            realW = col.width;
          } else {
            if (col.minsize) {
              var minSize = parseInt(col.minsize);
              if (w < minSize) {
                realW = minSize;
              }
            }
            if (col.maxsize) {
              var maxSize = parseInt(col.maxsize);
              if (w > maxSize) {
                realW = maxSize;
              }
            }
          }
          if (realW != w) {
            sizes[i].w = realW;
            sizes[i].realW = true;
            widthMaxed += w - realW; // rest der grösse berechnen
            // die auf den rest
            // aufgeteilt werden muss. (
            // hier können bewust auch
            // negative zahlen
            // entstehen!)
          } else {
            recalcSize += parseInt(col.displaysize);
          }
        }
      }
      if (widthMaxed > 0 && recalcSize > 0) {
        // width wurde begrenzt, die begrenzte width verteilen
        var i;
        for (i in scope.columns) {
          var col = scope.columns[i];
          if (sizes[i] && !sizes[i].realW) {
            // auf elemente dich
            // nicht max size haben
            // verteilen
            var w = Math.floor(
              parseInt(col.displaysize) * widthMaxed / recalcSize
            ); // calculated
            // column width
            sizes[i].w += w;
            sizes[i].added = w;
            // note: aktuell ignorieren wir wenn beim zweiten
            // verteilen die size überschritten würde
          }
        }
      }

      var i;
      for (i in scope.columns) {
        var col = scope.columns[i];
        if (sizes[i]) {
          col.visible = true;
          col.dWidth = sizes[i].w;
          // show column
        } else {
          col.dWidth = 0;
          col.visible = false;
        }
      }
    };
    return serviceInstance;
  };

  return service;
});
